import { Loader2, MapPinOff, Send } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export type DestinoDialogSemBiometria = 'INPUT' | 'AGUARDANDO HP' | 'AUDITORIA CPF';

interface SemBiometriaDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  destino: DestinoDialogSemBiometria;
  numeroPedido: string;
  razaoSocial: string;
  isLoading: boolean;
  onConfirm: () => void;
}

const TEXTO: Record<DestinoDialogSemBiometria, { titulo: string; corpo: string; botao: string }> = {
  INPUT: {
    titulo: 'Pedido criado: enviar para Input?',
    corpo: 'Fibra e CPF não têm biometria nem aceite. Conseguiu criar o pedido, ele vai direto para o Input; lá você coloca a agenda e segue para Input realizado.',
    botao: 'Enviar para Input',
  },
  'AGUARDANDO HP': {
    titulo: 'Não deu para criar: enviar para Aguardando HP?',
    corpo: 'Use quando a fibra travou na criação porque o endereço não está liberado. Quando o HP liberar, o pedido volta direto para o Input.',
    botao: 'Enviar para Aguardando HP',
  },
  'AUDITORIA CPF': {
    titulo: 'Auditoria feita: enviar para Input?',
    corpo: 'No CPF o contrato é a auditoria por voz da supervisora. Feita a auditoria, o pedido fica no seu nome e vai direto para o Input, sem biometria nem aceite.',
    botao: 'Enviar para Input',
  },
};

export function SemBiometriaDialog({
  open,
  onOpenChange,
  destino,
  numeroPedido,
  razaoSocial,
  isLoading,
  onConfirm,
}: SemBiometriaDialogProps) {
  const t = TEXTO[destino];
  const Icone = destino === 'AGUARDANDO HP' ? MapPinOff : Send;
  return (
    <Dialog open={open} onOpenChange={(aberto) => !isLoading && onOpenChange(aberto)}>
      <DialogContent className="sm:max-w-[520px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Icone className="h-5 w-5 text-primary" />
            {t.titulo}
          </DialogTitle>
          <DialogDescription>
            Pedido {numeroPedido} · {razaoSocial}
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-lg border border-border bg-muted/40 p-3 text-sm text-foreground">
          {t.corpo}
        </div>

        <div className="flex gap-2">
          <Button type="button" variant="outline" className="flex-1" onClick={() => onOpenChange(false)} disabled={isLoading}>
            Voltar
          </Button>
          <Button type="button" className="flex-1" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Enviando...
              </>
            ) : (
              <>
                <Icone className="mr-2 h-4 w-4" />
                {t.botao}
              </>
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
